import { SettingIcon, VolumeOff, VolumeOn } from 'assets/icons';
import { useDispatch, useSelector } from 'react-redux';
import { setGlobalAudioPlaying } from 'store/actions';
import './styles.scss';
import DropdownMenu from 'components/DropdownMenu';
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import { useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const SettingControl = ({
  className = '',
  side = 'bottom',
  align = 'end',
}) => {
  return (
    <DropdownMenu className={`setting-control ${className}`}>
      <DropdownMenu.Trigger>
        <SettingIcon color="white" size={30} />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content side={side} align={align}>
        <AudioControl />
        <LangControl />
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};

const AudioControl = ({ className = '' }) => {
  const dispatch = useDispatch();
  const { isPlaying } = useSelector((state) => state.globalAudio);

  const toggleAudio = () => {
    dispatch(setGlobalAudioPlaying(!isPlaying));
  };

  return (
    <button
      className={`audio-control-button ${className} ${
        isPlaying ? 'active' : ''
      }`}
      onClick={toggleAudio}
    >
      {isPlaying ? (
        <VolumeOn color="white" size={20} />
      ) : (
        <VolumeOff color="white" size={20} />
      )}
    </button>
  );
};

const LangControl = () => {
  const { search } = useLocation();
  const history = useHistory();
  const { i18n } = useTranslation();

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const lang = searchParams.get('lang') || i18n.language || 'vi';

  // Sync i18next with URL on mount and when URL changes
  useEffect(() => {
    const urlLang = searchParams.get('lang');
    if (urlLang && urlLang !== i18n.language) {
      i18n.changeLanguage(urlLang);
    }
  }, [searchParams, i18n]);

  const toggleLang = () => {
    const newLang = lang === 'en' ? 'vi' : 'en';
    searchParams.set('lang', newLang);

    // Update URL first
    history.replace({ search: searchParams.toString() });
    // Then change i18next language
    i18n.changeLanguage(newLang);
  };

  return (
    <button className="lang-control-button" onClick={toggleLang}>
      {lang.toUpperCase()}
    </button>
  );
};
